var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[_c('div',{staticClass:"logo-container"},[(_vm.customLogoUrl)?_c('img',{staticClass:"logo",attrs:{"src":_vm.customLogoUrl,"alt":"Welcome"}}):_c('img',{staticClass:"logo",attrs:{"src":require("../../public/en_logo.png"),"alt":"Welcome"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }